import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    personalNovedades: [],
    /* Filtro */
    fechaDesde: moment(new Date()).add(-60, 'days').format('YYYY-MM-DD'),
    fechaHasta: moment(new Date()).format('YYYY-MM-DD'),
    tipoNovedad: null,
    personal: null,

    novedades: [],
    periodo: []
};

const mutations = {
    updateField,

    'INICIALIZAR' (state) {
        state.personalNovedades = [];
        state.novedades = [];
        state.periodo = [];
    },
    'SET_PERSONAL_NOVEDADES' (state, personalNovedades) {
        state.personalNovedades = personalNovedades;

        state.novedades = [];
        for(let key in personalNovedades) {
            const novedad = personalNovedades[key];

            let fechaDesde = moment.utc(new Date(novedad.fechaDesde)).format("YYYY-MM-DD");
            let fechaHasta = moment.utc(new Date(novedad.fechaHasta)).format("YYYY-MM-DD");
            
            if ( fechaDesde < state.fechaDesde ) {
                fechaDesde = state.fechaDesde;
            }
            if ( fechaHasta > state.fechaHasta ) {
                fechaHasta = state.fechaHasta;
            }

            const diffTime = Math.abs( new Date(fechaHasta).getTime() - new Date(fechaDesde).getTime());
            const duracion = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
            
            console.log(novedad.personal, diffTime, duracion);

            let color = '#828282';
            if (novedad.color) {
                if (novedad.color.trim() != '') {
                    color = novedad.color.trim();
                }
            }

            const task = {
                index: novedad.id,
                sdate: moment(fechaDesde).format("YYYY-MM-DD"),
                duration: duracion,
                edate: moment(fechaHasta).format("YYYY-MM-DD"),
                isActive: false,
                title: "",
                desc: "",
                weekday: 0,
                space: 0,
                canHasFollowingTasks: false,
                /* Color de la barra a partir del tipo de falta */
                color: color
            }
            task[moment(fechaDesde).format("YYYY-MM-DD")] = task;

            /* Verificamos si existia el personal */
            let item = state.novedades.find(item => item.user.name.trim() == novedad.personal.trim());

            if (item) {
                item.tasks.push(task);
                item.total += 1;

            } else {
                item = {};
                
                item.user = {
                    name: novedad.personal
                };
                item.tasks = [];

                item.tasks.push(task);
                item.total = 1;
                
                state.novedades.push(item);            
            }

            console.log(task, item);
        }

        const diffTime = Math.abs( new Date(state.fechaHasta).getTime() - new Date(state.fechaDesde).getTime());
        const dias = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
    
        state.periodo = [];
        for (let index = 0; index < dias; index++) {
            const fecha = moment.utc(new Date(state.fechaDesde)).add(index, 'days').format("YYYY-MM-DD");
            state.periodo.push(fecha);
        }
    },
};

const actions = {
    getPersonalNovedades: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit ('INICIALIZAR');

            let queryString = '?fechaDesde='+ moment(state.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(state.fechaHasta).format('YYYY-MM-DD');
          
            if (state.personal) {
                if (state.personal.id) {
                    if (state.personal.id != 0) {
                        queryString += '&personalId=' + state.personal.id;
                    }
                }
            }
            
            if (state.tipoNovedad) {
                if (state.tipoNovedad.id) {
                    if (state.tipoNovedad.id != 0) {
                        queryString += '&tipoNovedadId=' + state.tipoNovedad.id;
                    }
                }
            }

            apiAxios.get('personalnovedades/calendario' + queryString)
            .then(res => {
                commit ('SET_PERSONAL_NOVEDADES', res.data);
                resolve();
            })
            .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
};

const getters = {
    getField,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}